import { render, staticRenderFns } from "./addon-button.vue?vue&type=template&id=0302fa36"
import script from "./addon-button.vue?vue&type=script&lang=js"
export * from "./addon-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports